export default __webpack_public_path__ + "static/media/mv.32296ef6.svg";